import React, { useEffect } from 'react';

import { 
  Card, 
  MarginTop,
  MarginBottom,
  CardContain
} from './Styled';

import StripeAddCard from './StripeAddCard';
import StripeActiveCard from './StripeActiveCard';

import Text from 'components/Text';
import Button from 'components/Button';
import CardDisplay from 'components/common/Card';

import Conditional from 'components/Conditional';
import { ErrorMessage } from 'components/ErrorMessage';
import { ACCOUNT_CARD } from 'constants/errors';

export const AccountCard = ({
  card,
  error,
  getCard,
  addCard,
  sourceId,
  errorSet,
  errorClear,
  removeCard,
  loadingCard,
  userIsAdmin,
  isLoadingCard
}) => {
  useEffect(() => {
    errorClear();
    getCard();
  }, [getCard, errorClear, sourceId]);

  var addCardHandler = (stripe) => {
    loadingCard(true);
    errorClear();

    stripe
      .createToken({ name: 'searchlight_account_card' })
      .then((res) => {
        if (!res.token) {
          loadingCard(false);

          if (res.error) {
            errorSet({ ...res.error, type: ACCOUNT_CARD })
          }
        } else {
          addCard({ stripe_source_id: res.token.id });
        }

      })
      .catch((err) => {
        err && loadingCard(false);
      });
  };

  return (
    <CardContain>
      <Card>
        <div style={{ maxWidth: 640 }}>
          <MarginBottom>
            <CardDisplay.SubTitle>
              {card ? 'Active Card' : 'Add Account Card'}
            </CardDisplay.SubTitle>
            <Text.Info>Add or remove an account card</Text.Info>
          </MarginBottom>

          <Conditional show={!card}>
            <StripeAddCard
              renderSubmit={(stripe) => userIsAdmin && (
                <MarginTop>
                  <Button.Default
                    inline
                    label="Add Card"
                    loading={isLoadingCard}
                    disabled={isLoadingCard}
                    onClick={addCardHandler.bind(null, stripe)}
                  />
                </MarginTop>
              )}
            />
          </Conditional>

          <Conditional show={card}>
            <StripeActiveCard
              card={card}
              renderRemove={() => userIsAdmin && (
                <MarginTop>
                  <Button.Default
                    inline
                    label="Remove Card"
                    onClick={removeCard}
                    loading={isLoadingCard}
                    disabled={isLoadingCard}
                  />
                </MarginTop>
              )}
            />
          </Conditional>

          <ErrorMessage error={error} />
        </div>
      </Card>
    </CardContain>
  );
};

export default AccountCard;
